"use client"

import { Component, useState } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import { getUserLocation } from "../../utils/location"
import routes from "../../routes/URL"
import IsolatedStatusModal  from "../../components/StatusModal"
import Toast from "../../components/Toast"
import {
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Typography,
  Button,
  IconButton,
  Input,
  Grid,
  Box,
  Container,
  Card,
  CardContent,
  CardHeader,

} from "@mui/material"

import EditIcon from "@mui/icons-material/Edit"

const FileUploadWithPreview = ({ label, id, name, accept, onChange }) => {
  const [file, setFile] = useState(null)

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]
    setFile(selectedFile)

    if (onChange) {
      onChange(selectedFile)
    }
  }

  const handleUploadClick = () => {
    document.getElementById(id).click()
  }

  return (
    <Box>
      <input type="file" id={id} style={{ display: "none" }} accept={accept} onChange={handleFileChange} name={name} />

      <Box
        sx={{
          border: "2px dashed #ccc",
          padding: "20px",
          textAlign: "center",
          cursor: "pointer",
          marginTop: "10px",
          borderRadius: "8px",
          backgroundColor: "rgba(0, 0, 0, 0.02)",
          transition: "all 0.3s ease",
          "&:hover": {
            borderColor: "#FFC857",
            backgroundColor: "rgba(255, 200, 87, 0.05)",
          },
        }}
        onClick={handleUploadClick}
      >
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item>
            <Box sx={{ fontSize: "30px", color: "#FFC857" }}>
              <i className="fa fa-upload"></i>
            </Box>
          </Grid>
          <Grid item>
            <Typography variant="subtitle1">{label}</Typography>
          </Grid>
        </Grid>
      </Box>

      {file && (
        <Box mt={2} textAlign="center">
          <img
            src={URL.createObjectURL(file) || "/placeholder.svg"}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "4px" }}
          />
        </Box>
      )}
    </Box>
  )
}

const CircularSkeletonWithEdit = () => {
  const [previewImage, setPreviewImage] = useState(null)

  const handleEditClick = () => {
    try {
      document.getElementById("hotel_logo").click()
    } catch (e) {}
  }

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]
    console.log("Selected File:", selectedFile)

    var reader = new FileReader()

    reader.onload = (e) => {
      setPreviewImage(e.target.result)
    }

    reader.readAsDataURL(selectedFile)
  }

  return (
    <Box
      onClick={handleEditClick}
      sx={{
        cursor: "pointer",
        position: "relative",
        width: 100,
        height: 100,
      }}
    >
      {previewImage != null ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: 100,
              height: 100,
              backgroundColor: "#02111B",
              borderRadius: "50%",
            }}
          >
            <img
              src={previewImage || "/placeholder.svg"}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
              alt="Logo"
            />
          </Box>
          <Typography variant="subtitle1" sx={{ mt: 2, color: "white" }}>
            Logo
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: 100,
              height: 100,
              backgroundColor: "#041A29",
              borderRadius: "50%",
            }}
          ></Box>
          <Typography variant="subtitle1" sx={{ mt: 2, color: "white" }}>
            Logo
          </Typography>
        </Box>
      )}

      <IconButton
        sx={{
          position: "absolute",
          bottom: 0,
          right: 0,
          backgroundColor: "#FFC857",
          color: "#02111B",
          "&:hover": {
            backgroundColor: "#E6B54E",
          },
        }}
      >
        <EditIcon />
      </IconButton>

      <Input
        id="hotel_logo"
        type="file"
        name="logo"
        sx={{
          display: "none",
        }}
        onChange={handleFileChange}
      />
    </Box>
  )
}

const SquareSkeletonWithEdit = () => {
  const [previewImage, setPreviewImage] = useState(null)

  const handleEditClick = () => {
    try {
      document.getElementById("hotel_photo").click()
    } catch (e) {}
  }

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]
    console.log("Selected File:", selectedFile)

    var reader = new FileReader()

    reader.onload = (e) => {
      setPreviewImage(e.target.result)
    }

    reader.readAsDataURL(selectedFile)
  }

  return (
    <Box
      onClick={handleEditClick}
      sx={{
        cursor: "pointer",
        position: "relative",
        width: "100%",
        maxWidth: 320,
        height: 180,
      }}
    >
      {previewImage != null ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: 180,
            maxWidth: "100%",
          }}
        >
          <img
            src={previewImage || "/placeholder.svg"}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
            }}
            alt="Cover Image"
          />
          <Typography variant="subtitle1" sx={{ mt: 2, color: "white" }}>
            Cover Image
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: 180,
            maxWidth: "100%",
          }}
        >
          <Box
            sx={{
              height: 180,
              maxWidth: "100%",
              width: "100%",
              backgroundColor: "#041A29",
              borderRadius: "8px",
            }}
          ></Box>
          <Typography variant="subtitle1" sx={{ mt: 2, color: "white" }}>
            Cover Image
          </Typography>
        </Box>
      )}

      <IconButton
        sx={{
          position: "absolute",
          bottom: 8,
          right: 8,
          backgroundColor: "#FFC857",
          color: "#02111B",
          "&:hover": {
            backgroundColor: "#E6B54E",
          },
        }}
      >
        <EditIcon />
      </IconButton>

      <Input
        id="hotel_photo"
        type="file"
        name="hotel_photo"
        sx={{
          display: "none",
        }}
        onChange={handleFileChange}
      />
    </Box>
  )
}

class ListHotelScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      locationData: {},
      formattedLocation: "",
      longitude: "",
      lattitude: "",
      postcode: "",
      state: "",
      state_district: "",
      outlet: "Restaurant",
      outletCategories: [],
      isModalOpen: false,
      modalType: "success", // or "error"
      modalTitle: "",
      modalMessage: "",
      modalButtonText: "Close",
      toast: {
        open: false,
        message: "",
        severity: "success" // can be "success", "error", etc.
      }
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    })
  }
  
  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    })
  }

  componentDidMount() {
    this.userLocation()
    this.getRestroOutletCategory()
  }

  openModal = (type, title, message, buttonText = "Close") => {
    this.setState({
      isModalOpen: true,
      modalType: type,
      modalTitle: title,
      modalMessage: message,
      modalButtonText: buttonText,
    });
  };
  
  closeModal = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  getRestroOutletCategory = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.getRestroOutletCategory)

    if (status === "success") {
      console.log("outlet category", data)
      this.setState({
        outletCategories: data,
      })
    } else {
      this.showToast(message, "error")
    }
  }

 userLocation = () => {
  getUserLocation((response) => {
    if (response) {
      const {
        lattitude,
        longitude,
        formatted,
        obj: { postcode, state, state_district },
      } = response
      console.log("user location",JSON.stringify({ formatted }))

      this.setState({
        longitude,
        lattitude,
        postcode,
        state,
        state_district,
      })
    }
  })
}


  createHotel = async () => {
    const formdata = new FormData(document.getElementById("hotelForm"))
    console.log(formdata)
    const { status, message, data } = await API(this, "post", URL_PATH.addHotel, formdata)
console.log("dsfsdfsdfsdf",status, message, data)
    if (status === "success") {
      console.log("ConsoleLog,Going to Dashborad")
      // this.showToast( message, "Go to Dashboard", () => {
        this.props.history.push(routes.admin.dashboard.root);
      // });
    } else {
      this.showToast(message, "error")

    }
  }

  render() {
    const {
      isModalOpen,
      modalType,
      modalTitle,
      modalMessage,
      modalButtonText,
    } = this.state;
    let outlet = this.state.outlet.replace("_", " ")
    outlet = outlet[0].toUpperCase() + outlet.slice(1)

    return (
      <Container maxWidth="xl" sx={{ py: 4, color: "white", minHeight: "100vh" }}>
        <form
          id="hotelForm"
          name="hotelForm"
          onSubmit={(e) => {
            e.preventDefault()
            return this.createHotel()
          }}
          noValidate
        >
          <Card sx={{ mb: 4, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
            <CardHeader
              title={
                <Typography variant="h5" sx={{ color: "white" }}>
                  Basic Information
                </Typography>
              }
              sx={{ borderBottom: "1px solid rgba(255, 200, 87, 0.2)" }}
            />
            <CardContent>
              <Grid container spacing={3} alignItems="center" justifyContent="center">
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={1}
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "center", md: "flex-start" },
                    mb: { xs: 2, md: 0 },
                  }}
                >
                  <CircularSkeletonWithEdit />
                </Grid>

                <Grid item xs={12} sm={12} md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={2}>
                      <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                        <InputLabel id="type-select-label" sx={{ color: "white" }}>
                          Type
                        </InputLabel>
                        <Select
                          id="category"
                          name="outlet_category"
                          value={this.state.outlet}
                          label="Type"
                          onChange={(e) => {
                            this.setState({
                              outlet: e.target.value,
                            })
                          }}
                          sx={{
                            backgroundColor: "#02111B",
                            backgroundImage: "none",
                            color: "white",
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                backgroundColor: "#02111B",
                                backgroundImage: "none",
                                color: "white",
                                "& .MuiMenuItem-root": {
                                  "&:hover": {
                                    backgroundColor: "#041A29",
                                  },
                                },
                              },
                            },
                          }}
                        >
                          {this.state.outletCategories.map((item, index) => (
                            <MenuItem key={index} value={item.value} sx={{ color: "white" }}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                        <TextField
                          variant="outlined"
                          type="text"
                          id="name"
                          name="hotel_name"
                          label={`Enter ${outlet} name`}
                          InputLabelProps={{ style: { color: "white" } }}
                          InputProps={{
                            style: { color: "white" },
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                        <TextField
                          variant="outlined"
                          type="text"
                          id="owner"
                          name="owner_name"
                          label="Enter owner name"
                          InputLabelProps={{ style: { color: "white" } }}
                          InputProps={{
                            style: { color: "white" },
                          }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={2}>
                      <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                        <InputLabel id="country-code-label" sx={{ color: "white" }}>
                          Country
                        </InputLabel>
                        <Select
                          id="country_code"
                          name="country_code"
                          label="Country"
                          value={this.state.hotel_phone_country_code || "+91"}
                          onChange={(e) => {
                            this.setState({
                              hotel_phone_country_code: e.target.value,
                            })
                          }}
                          sx={{
                            backgroundColor: "#02111B",
                            backgroundImage: "none",
                            color: "white",
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                backgroundColor: "#02111B",
                                backgroundImage: "none",
                                color: "white",
                                "& .MuiMenuItem-root": {
                                  "&:hover": {
                                    backgroundColor: "#041A29",
                                  },
                                },
                              },
                            },
                          }}
                        >
                          {[
                            {
                              country_code: "+91",
                              country_name: "India",
                              country_flag_unicode: "🇮🇳",
                            },
                            {
                              country_code: "+1",
                              country_name: "United States",
                              country_flag_unicode: "🇺🇸",
                            },
                            {
                              country_code: "+44",
                              country_name: "United Kingdom",
                              country_flag_unicode: "🇬🇧",
                            },
                          ].map((item, index) => (
                            <MenuItem key={index} value={item.country_code} sx={{ color: "white" }}>
                              {item.country_flag_unicode} {item.country_code} {item.country_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                      <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                        <TextField
                          variant="outlined"
                          type="text"
                          id="phone"
                          name="phone"
                          label={`${outlet} Phone`}
                          InputLabelProps={{ style: { color: "white" } }}
                          InputProps={{
                            style: { color: "white" },
                          }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6}>
                      <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                        <TextField
                          variant="outlined"
                          type="text"
                          id="email"
                          name="email"
                          label={`${outlet} Email`}
                          InputLabelProps={{ style: { color: "white" } }}
                          InputProps={{
                            style: { color: "white" },
                          }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
  <Grid item xs={12} sm={6} md={2}>
    <FormControl variant="outlined" fullWidth>
      <TextField
        variant="outlined"
        type="text"
        id="gst_number"
        name="gst_number"
        label="GST Number"
        InputLabelProps={{ style: { color: "white" } }}
        InputProps={{
          style: { color: "white" },
        }}
      />
    </FormControl>
  </Grid>

  <Grid item xs={12} sm={6} md={2}>
    <FormControl variant="outlined" fullWidth>
      <TextField
        variant="outlined"
        type="text"
        id="fssai_number"
        name="fssai_number"
        label="FSSAI Number"
        InputLabelProps={{ 
          style: { color: "white" },
          shrink: true // This ensures the label doesn't overlap with the value
        }}
        InputProps={{
          style: { color: "white" },
        }}
        // Add validation pattern if needed
        inputProps={{
          pattern: "[0-9]{14}", // FSSAI numbers are typically 14 digits
          title: "Please enter a valid 14-digit FSSAI number"
        }}
      />
    </FormControl>
  </Grid>

  <Grid item xs={12} sm={4}>
    {/* Website field remains here */}
    <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
      <TextField
        variant="outlined"
        type="text"
        id="website"
        name="website"
        label={`${outlet} Website (Optional)`}
        InputLabelProps={{ style: { color: "white" } }}
        InputProps={{
          style: { color: "white" },
        }}
      />
    </FormControl>
  </Grid>

  <Grid item xs={12} sm={6}>
    {/* Google Review field remains here */}
    <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
      <TextField
        variant="outlined"
        type="text"
        id="google_review_link"
        name="google_review_link"
        label={`${outlet} Google Review Link (Optional)`}
        InputLabelProps={{ style: { color: "white" } }}
        InputProps={{
          style: { color: "white" },
        }}
      />
    </FormControl>
  </Grid>
</Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={2}
                  sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-end" } }}
                >
                  <SquareSkeletonWithEdit />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card sx={{ mb: 4, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
            <CardHeader
              title={
                <Typography variant="h5" sx={{ color: "white" }}>
                  Address Information
                </Typography>
              }
              sx={{ borderBottom: "1px solid rgba(255, 200, 87, 0.2)" }}
            />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4} lg={2}>
                  <FormControl fullWidth sx={{ mb: { xs: 2, md: 0 } }}>
                    <TextField
                      variant="outlined"
                      type="text"
                      id="address_line_1"
                      name="address"
                      label="Address Line 1"
                      InputLabelProps={{ style: { color: "white" } }}
                      InputProps={{
                        style: { color: "white" },
                      }}
                      
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={2}>
                  <FormControl fullWidth sx={{ mb: { xs: 2, md: 0 } }}>
                    <TextField
                      variant="outlined"
                      type="text"
                      id="address_line_2"
                      name="apartment"
                      label="Address Line 2"
                      InputLabelProps={{ style: { color: "white" } }}
                      InputProps={{
                        style: { color: "white" },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={2}>
                  <FormControl fullWidth sx={{ mb: { xs: 2, md: 0 } }}>
                    <TextField
                      variant="outlined"
                      type="text"
                      id="city"
                      name="city"
                      label="City"
                      InputLabelProps={{ style: { color: "white" } }}
                      InputProps={{
                        style: { color: "white" },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={2}>
                  <FormControl fullWidth sx={{ mb: { xs: 2, md: 0 } }}>
                    <TextField
                      variant="outlined"
                      type="text"
                      id="state"
                      name="state"
                      label="State"
                      InputLabelProps={{ style: { color: "white" } }}
                      InputProps={{
                        style: { color: "white" },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={2}>
                  <FormControl fullWidth sx={{ mb: { xs: 2, md: 0 } }}>
                    <TextField
                      variant="outlined"
                      type="text"
                      id="country"
                      name="country"
                      label="Country"
                      InputLabelProps={{ style: { color: "white" } }}
                      InputProps={{
                        style: { color: "white" },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={2}>
                  <FormControl fullWidth>
                    <TextField
                      variant="outlined"
                      type="text"
                      id="pincode"
                      name="pin_code"
                      label="Pincode"
                      InputLabelProps={{ style: { color: "white" } }}
                      InputProps={{
                        style: { color: "white" },
                      }}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12} sm={6} md={5} lg={5}>
                  <FormControl variant="outlined" fullWidth>
                    <TextField
                      variant="outlined"
                      type="text"
                      id="lat"
                      name="lat"
                      label="Enter latitude"
                      value={this.state.lattitude}
                      onChange={(e) => {
                        this.setState({
                          lattitude: e.target.value,
                        })
                      }}
                      InputLabelProps={{ style: { color: "white" } }}
                      InputProps={{
                        style: { color: "white" },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={5} lg={5}>
                  <FormControl variant="outlined" fullWidth>
                    <TextField
                      variant="outlined"
                      type="text"
                      id="lng"
                      name="lng"
                      label="Enter longitude"
                      value={this.state.longitude}
                      onChange={(e) => {
                        this.setState({
                          longitude: e.target.value,
                        })
                      }}
                      InputLabelProps={{ style: { color: "white" } }}
                      InputProps={{
                        style: { color: "white" },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={2}>
                  <FormControl variant="outlined" fullWidth>
                    <Button
                      type="button"
                      variant="contained"
                      onClick={() => {
                        this.userLocation()
                      }}
                      sx={{
                        backgroundColor: "#FFC857",
                        color: "#02111B",
                        fontWeight: "bold",
                        "&:hover": {
                          backgroundColor: "#E6B54E",
                        },
                        height: "56px",
                      }}
                    >
                      <i className="fa fa-map-marker" style={{marginRight:"4px",size:"6px"}}></i>  Detect Location
                    </Button>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

      

          <Card sx={{ mb: 4, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
            <CardHeader
              title={
                <Typography variant="h5" sx={{ color: "white" }}>
                  Documents
                </Typography>
              }
              sx={{ borderBottom: "1px solid rgba(255, 200, 87, 0.2)" }}
            />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <FileUploadWithPreview
                    label="Upload Shop Act license"
                    id="shopAct"
                    name="shop_act_file"
                    accept="image/*"
                    onChange={(file) => {
                      // handle file change here, if needed
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FileUploadWithPreview
                    label="Upload FSSAI license"
                    id="fssai"
                    name="fssai_file"
                    accept="image/*"
                    onChange={(file) => {
                      // handle file change here, if needed
                    }}
                  />
                </Grid>

                {/* <Grid item xs={12} sm={6} md={4}>
                  <FileUploadWithPreview
                    label="Upload Adhar Card"
                    id="adhar"
                    name="adhar_file"
                    accept="image/*"
                    onChange={(file) => {
                      // handle file change here, if needed
                    }}
                  />
                </Grid> */}

                <Grid item xs={12} sm={6} md={4}>
                  <FileUploadWithPreview
                    label="Upload GST Certificate"
                    id="gst"
                    name="gst_file"
                    accept="image/*"
                    onChange={(file) => {
                      // handle file change here, if needed
                    }}
                  />
                </Grid>

                {/* <Grid item xs={12} sm={6} md={4}>
                  <FileUploadWithPreview
                    label="Upload Pan Card"
                    id="pan"
                    name="pan_file"
                    accept="image/*"
                    onChange={(file) => {
                      // handle file change here, if needed
                    }}
                  />
                </Grid> */}

                {/* <Grid item xs={12} sm={6} md={4}>
                  <FileUploadWithPreview
                    label="Upload Cancelled Cheque"
                    id="cancelled_cheque"
                    name="cancelled_cheque_file"
                    accept="image/*"
                    onChange={(file) => {
                      // handle file change here, if needed
                    }}
                  />
                </Grid> */}
              </Grid>
            </CardContent>
          </Card>

          <Card sx={{ mb: 4, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
            <CardHeader
              title={
                <Typography variant="h5" sx={{ color: "white" }}>
                  Referral Program (Optional)
                </Typography>
              }
              sx={{ borderBottom: "1px solid rgba(255, 200, 87, 0.2)" }}
            />
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <FormControl variant="outlined" fullWidth>
                    <TextField
                      variant="outlined"
                      type="text"
                      id="referal_code"
                      name="referal_code"
                      label="Enter referral code"
                      InputLabelProps={{ style: { color: "white" } }}
                      InputProps={{
                        style: { color: "white" },
                      }}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Box mt={4} textAlign="start">
            <Button
              variant="contained"
              size="large"
              type="submit"
              sx={{
                backgroundColor: "#FFC857",
                color: "#02111B",
                fontWeight: "bold",
                px: 4,
                py: 1.5,
                "&:hover": {
                  backgroundColor: "#E6B54E",
                },
              }}
            >
              Register {outlet}
            </Button>
          </Box>
        </form>
        <Toast
  open={this.state.toast.open}
  message={this.state.toast.message}
  severity={this.state.toast.severity}
  handleClose={this.handleCloseToast}
/>
      </Container>
    )
  }
}

export default redux(ListHotelScreen)

